import { render, staticRenderFns } from "./PackStoreItem.vue?vue&type=template&id=b05dfdbe&scoped=true"
import script from "./PackStoreItem.vue?vue&type=script&lang=js"
export * from "./PackStoreItem.vue?vue&type=script&lang=js"
import style0 from "./PackStoreItem.vue?vue&type=style&index=0&id=b05dfdbe&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b05dfdbe",
  null
  
)

export default component.exports